import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'accordionjs';
import L from 'leaflet';
import hcSticky from 'hc-sticky';
import 'stacktable.js';

import 'leaflet/dist/leaflet.css';
import 'accordionjs/accordion.css';

// eslint-disable-next-line no-undef
const gsObject = gs_object;

$('.gs-table').stacktable();

new hcSticky('.program-right-inner', { top: 30 });

$('.program-accordions').accordionjs({
    activeIndex: false,
});

// $('.program-gallery').lightGallery({
//     selector: '.gallery-item',
//     download: false,
//     counter: false,
// });

// new Swiper('.gallery-slider', {
//     loop: false,
//     slidesPerView: 2,
//     spaceBetween: 0,
// });

$('.more-button').on('click', function () {
    $('.location-desc').toggleClass('active');
    $(this).toggleClass('active');
});

if ('0' !== gsObject.lat && '0' !== gsObject.long) {
    const map = L.map('gs-map').setView([gsObject.lat, gsObject.long], 15);

    L.tileLayer(
        'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
        {
            attribution: '',
            maxZoom: 18,
            id: 'mapbox/light-v10',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: gsObject.mapBox,
        }
    ).addTo(map);

    var mapIcon = L.icon({
        iconUrl: gsObject.markerUrl,
    });

    L.marker([gsObject.lat, gsObject.long], { icon: mapIcon }).addTo(map);
}

$(document).on('click', 'a[href^="#"]', function (e) {
    const id = $(this).attr('href');

    const $id = $(id);
    if ($id.length === 0) {
        return;
    }

    e.preventDefault();

    var pos = $id.offset().top;

    $('body, html').animate({ scrollTop: pos });
});
